import React from 'react';

interface LoaderProps {
	size?: 'sm' | 'md' | 'lg' | 'xl';
	text?: string;
	className?: string;
	color?: 'blue' | 'gray' | 'green' | 'red' | 'yellow';
}

const Loader: React.FC<LoaderProps> = ({
	size = 'md',
	text = 'Loading...',
	className = '',
	color = 'blue',
}) => {
	const sizeClasses = {
		sm: 'h-4 w-4',
		md: 'h-6 w-6',
		lg: 'h-8 w-8',
		xl: 'h-12 w-12',
	};

	const textSizes = {
		sm: 'text-xs',
		md: 'text-sm',
		lg: 'text-base',
		xl: 'text-lg',
	};

	const colorClasses = {
		blue: 'border-primary-600',
		gray: 'border-neutral-600',
		green: 'border-sa-success-600',
		red: 'border-sa-error-600',
		yellow: 'border-sa-warning-600',
	};

	return (
		<div
			className={`flex flex-col items-center justify-center w-full h-full font-primary ${className}`}
		>
			<div
				className={`animate-spin rounded-full border-b-2 ${sizeClasses[size]} ${colorClasses[color]}`}
				aria-hidden="true"
			/>
			{text && (
				<p
					className={`mt-3 text-neutral-600 font-medium font-primary ${textSizes[size]}`}
				>
					{text}
				</p>
			)}
		</div>
	);
};

export default Loader;
